<template>
  <div class="PageBox">
    <div class="ScrollBox">
      <div class="Contract">
        <div v-html="infoData.agreement"></div>
        <img class="CompanySeal" :src="InitData.setting.up_url+infoData.party_b_icon" width="28%" v-if="infoData.party_b_icon">
        <img class="GuaranteeSeal" :src="InitData.setting.up_url+infoData.party_c_icon" width="28%"  v-if="infoData.party_c_icon">
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {
    
  },
  props: ['orderId'],
  data() {
    return {
      infoData: '',
    }
  },
  computed: {

  },
  watch: {

  },
  created() {
    this.$parent.navBarTitle = this.$t('InvestDetail[15]')
    this.$Model.InvestContract({orderid: this.orderId},(data)=>{
      this.infoData = data.info
    })
  },
  mounted() {

  },
  activated() {

  },
  destroyed() {
    
  },
  methods: {
   
  }
}
</script>
<style scoped>
.Contract{
  padding: 20px 10px;
  position: relative;
  background-color: #fff;
  min-height: 100%;
  color: #000;
}
.Contract>>>table{
  width: 100%;
}
.Contract>>>table td{
  border: 1px #eee solid;
  width: auto;
}
.CompanySeal{
  position: absolute;
  right: 10px;
  bottom: 100px;
}
.GuaranteeSeal{
  position: absolute;
  left: 10px;
  bottom: 10px;
}
</style>